import { formatHtml } from "@trumpf/ux.common-storybook";
import { getIframePageDecorators } from "../../../shared/page";
import { SearchPageTemplate } from "./search-page.templates";
import {
    sourceNoResults,
    SearchResultTabsTemplate,
} from "./search-results.templates";
import { slotGPT, slotTabs } from "./search-bar.templates";

export default {
    title: "Website/Page Templates/Search/Search Page",
    render: SearchPageTemplate.bind({}),
    decorators: getIframePageDecorators(),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
        layout: "fullscreen",
    },
    args: {
        autosuggestEndpoint: "./mock-data/search-bar/autocomplete-tru.json",
        buttonText: "Suchen",
        placeholder: "Suchbegriff eingeben",
        resultsLabel: "Suchergebnisse",
        searchString: "",
        searchFormSelector: "form#website-search-form",
        navTabContainerSelector: "ux-tab-container#search-nav-tabs",
        resultTabContainerSelector: "ux-tab-container#search-result-tabs",
    },
};

export const Search = {
    args: {
        autosuggestEndpoint: "",
    },
};

export const SearchAutoSuggest = {
    args: {
        autosuggestEndpoint: "./mock-data/search-bar/autocomplete-tru.json",
    },
};

export const NoResults = {
    args: {
        searchString: "FruTibre",
        _slotSearchResults: sourceNoResults.trim(),
    },
};

export const WithProductsTab = {
    args: {
        searchString: "Laser",
        _slotSearchBar: slotTabs.trim(),
        _slotSearchResults: SearchResultTabsTemplate({
            noNavigation: true,
            withFilter: true,
            withSort: true,
            withTabPages: true,
            withTabProducts: true,
            withTabGPT: true,
            withStaticResults: false,
        }),
    },
};

export const WithGPT = {
    args: {
        searchString: "Laser",
        _slotSearchBar: slotGPT.trim(),
        _slotSearchResults: SearchResultTabsTemplate({
            noNavigation: true,
            withFilter: true,
            withSort: true,
            withTabPages: true,
            withTabProducts: true,
            withTabGPT: true,
            withStaticResults: false,
        }),
    },
};
